import Typography from "@mui/material/Typography";
import classNames from "classnames";
import React, { useCallback } from "react";

interface PDFViewerProps {
  title?: string;
  fileUrl?: string;
  pages?: number[];
  className?: string;
}

const PDFViewer: React.FC<PDFViewerProps> = ({
  title,
  fileUrl,
  pages,
  className,
}: PDFViewerProps) => {
  const getUrl = useCallback(() => {
    let url = fileUrl;
    if (pages) {
      url = `${url}#page=${pages[0] + 1}`;
    }
    return url;
  }, [pages, fileUrl]);

  return (
    <div
      className={classNames(
        "flex flex-col overflow-hidden relative",
        className
      )}
    >
      {fileUrl ? (
        <iframe
          title={title}
          src={getUrl()}
          className="overflow-auto h-full w-full"
          style={{
            border: "none",
          }}
        />
      ) : (
        <Typography className="text-gray-500">No PDF file provided</Typography>
      )}
    </div>
  );
};

export default PDFViewer;
